/**
 *  Alaska: Editor
 *  Public: Partners contact form
 *
 *  @version 1.0
 */

document.addEventListener('alpine:init', () => {
  Alpine.data('PartnersContactForm', () => ({
    state: 'default',
    loading: false,

    form: {
      firstName: '',
      lastName: '',
      email: '',
      confirmEmail: '',
      referralName: '',
      referralEmail: '',
      contactNumber: '',
      confirmReferralEmail: '',
      message: '',
      newsletter: false,
    },

    errors: {
      firstName: '',
      lastName: '',
      email: '',
      confirmEmail: '',
      referralName: '',
      referralEmail: '',
      contactNumber: '',
      confirmReferralEmail: '',
      message: '',
      newsletter: false,
    },

    // ---- State ---- //

    get loading_state() {
      return this.loading === true;
    },

    get default_state() {
      return this.state === 'default' && this.loading === false;
    },

    get success_state() {
      return this.state === 'success' && this.loading === false;
    },

    reset() {
      setTimeout(() => {
        this.state = 'default';
        this.form = {
          firstName: '',
          lastName: '',
          email: '',
          confirmEmail: '',
          referralName: '',
          referralEmail: '',
          contactNumber: '',
          confirmReferralEmail: '',
          message: '',
          newsletter: false,
        };
        this.loading = false;
      }, 3000);
    },

    // ---- Form ---- //

    validate_form() {
      if (this.form.firstName.trim() === '') {
        this.errors.firstName = 'First name is required';
      } else {
        this.errors.firstName = '';
      }

      if (this.form.lastName.trim() === '') {
        this.errors.lastName = 'Last name is required';
      } else {
        this.errors.lastName = '';
      }

      if (this.form.email.trim() === '') {
        this.errors.email = 'Email address is required';
      } else {
        this.errors.email = '';
      }

      if (this.form.confirmEmail.trim() === '') {
        this.errors.confirmEmail = 'Email confirmation is required';
      } else {
        this.errors.confirmEmail = '';
      }

      if (this.form.email.trim() !== '' &&
        this.form.confirmEmail.trim() !== '' &&
        this.form.email !== this.form.confirmEmail
      ) {
        this.errors.confirmEmail = "Email addresses don't match";
      }

      if (this.form.referralName.trim() === '') {
        this.errors.referralName = 'Referral Name / Company is required';
      } else {
        this.errors.referralName = '';
      }

      if (this.form.referralEmail.trim() === '') {
        this.errors.referralEmail = 'Email address is required';
      } else {
        this.errors.referralEmail = '';
      }

      if (this.form.confirmReferralEmail.trim() === '') {
        this.errors.confirmReferralEmail = 'Email confirmation is required';
      } else {
        this.errors.confirmReferralEmail = '';
      }

      if (this.form.referralEmail.trim() !== '' &&
        this.form.confirmReferralEmail.trim() !== '' &&
        this.form.referralEmail !== this.form.confirmReferralEmail
      ) {
        this.errors.confirmReferralEmail = "Email addresses don't match";
      }

      if (this.form.message.trim() === '') {
        this.errors.message = 'Message is required';
      } else {
        this.errors.message = '';
      }

      let status = true;
      Object.keys(this.errors).forEach((input) => {
        if (this.errors[input].length > 0) {
          status = false;
        }
      });

      return status;
    },

    async submit() {
      if (!this.validate_form()) {
        Notification.render('Please fill out the required fields.', 'error');
        return;
      }

      this.loading = true;

      try {
        const response = await fetch('/alaska/public/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            controller: 'Marketing',
            action: 'partnerContact',
            data: this.form,
          }),
        });

        const result = await response.json();

        this.loading = false;

        if (result.type === 'success') {
          this.state = 'success';
          this.reset();
        }

        if (result.type === 'error') {
          Notification.render(result.message, 'error'); 
        }

      } catch (error) {
        console.error(error);
      }
    },
  }));
});
